// extracted by mini-css-extract-plugin
module.exports = {"container":"ReportPage_container__2oX3Y","link":"ReportPage_link__2ppIt","loading":"ReportPage_loading__15axX"};